import React from 'react'

const Yogmaya = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका शब्द र अर्थ बिच जोडा मिलाउनुहोस् :</h5>
        <p>(क) जलसमाध - पानीमा डुबेर गरिने प्राणत्याग</p>
        <p>(ख) बडाहाकि - राना शासनका समयमा र त्यसपछि पनि केही समय जिल्लाको सर्वोच्च प्रशाशक</p>
        <p>(ग) आर्य समाज - अनातन धर्ममा उदारता ल्याउन चलाइएको एक धार्मिक सम्प्रदाय</p>
        <p>(घ) वैधव्य - विधवा हुनाको भाव</p>
        <p>(ङ) हठयोग - पतञ्जलिद्वारा प्रतिपदित योग ( यम, नियम आदि) द्वारा शरीरलाई धेरै कष्ट दिएर चित्तवृत्तिलाई अन्तर्मुखी पार्ने योगको एक विधि</p>
        <p>(च) प्रताडना - पीडा</p>
        <p>(छ) विचारी - मुद्दामामिलाको निचोड खिचेर न्यायाधीशलाई अवगत गराउने व्यक्ति</p>
        <p>(ज) पञ्चाग्नि - वरिपरि पाँच किसिमका अग्नि बालेर गरिने तपस्या</p>
      </div>
      <hr/>
      <div>
        <h5>२. पाठपढी गाडा गरिएका पदावलीको सट्टामा मिल्ने शब्द छानेर लेख्नुहोस् :</h5>
        <p>(क) सन्यासी</p>
        <p>(ख) परम्परागत</p>
        <p>(ग) शास्त्रार्थ</p>
        <p>(घ) अग्निसमाधी</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका शब्द प्रयोग गरी वाक्य बनाउनुहोस् :</h5>
        <strong>स्वसिकाइ</strong>
        <p>रातभरि स्वसिकाइको आवाजले मलाई सुत्न दिइएन।</p>
        <strong>विद्रोह</strong>
        <p>अत्याचारविरुद्ध जनताले विद्रोह गरे।</p>
        <strong>सञ्जाल</strong>
        <p>सूचना प्रविधिले मानिसहरूलाई सामाजिक सञ्जालमार्फत जोडेको छ।</p>
        <strong>धाराप्रवाह</strong>
        <p>उहाँ धाराप्रवाह रूपमा अंग्रेजीमा बोल्नुहुन्छ।</p>
        <strong>योगसाधना</strong>
        <p>नियमित योगसाधनाले स्वास्थ्य राम्रो हुन्छ।</p>
        <strong>निराहार</strong>
        <p>उहाँले तीन दिनसम्म निराहार बस्नुभयो।</p>
        <strong>स्वेच्छिक</strong>
        <p>त्यो कार्यक्रममा सबैले स्वेच्छिक रूपमा भाग लिएका थिए।</p>
        <strong>यज्ञस्थल</strong>
        <p>पण्डितहरूले यज्ञस्थलमा मन्त्र पाठ गरिरहेका थिए।</p>
        <strong>स्मृति</strong>
        <p>यो तस्बिर मेरो बाल्यकालको स्मृति हो।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका शब्दहरु प्रयोग गरि एउटा अनुच्छेद लेख्नुहोस् ।</h5>
        <p>सासूससुरा भएको घर सबै दृष्टिकोणबाट राम्रो हुन्छ । बुहारीलाई सारोगारो हुँदा घरमा सासुससुराले हेर्ने गर्नुहुन्छ । नन्द आमाजूको उमेर र भाउजू वा बुहारीको उमेर समूह मिल्ने भएकाले उनीहरु मित्र साथी जस्तो व्यवहार हुन्छ । सम्धी र जेठान घरका इज्जतिला पाहुना हुन्। भदा भदैले पनि कहिलेकाही माइतीको तिर्सना मेट्छन् ।</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. पाठ पढ्नुहोस् र दिइएका प्रश्नहरुकोभन्नुहोस् :</h5>
        <h5>(क) योगमायाको जीवनी कति अनुच्छेदमा संरचित छ ?</h5>
        <p>= योगमायाको जीवनी नौ अनुच्छेदमा संरचित छ ।</p>
        <h5>(ख)चौथो अनुच्छेदमा कतिवटा वाक्य छन् ?</h5>
        <p>= चौथो अनुच्छेदमा २५ ओटा वाक्य छन् ।</p>
        <h5>(ग) दोस्रो अनुच्छेदमा योगमायाको जीवनी कुन अवस्थामा वर्णन छ ?</h5>
        <p>= दोस्रो अनुच्छेदमा योगमायाको जीवनीको वाल्यकालीन, वैवाहिक र पारिवारिक अवस्थामा वर्णन छ ।</p>
        <h5>(घ) योगमायाको जलसमाधिको सन्दर्भ कुन अनुच्छेदमा छ ?</h5>
        <p>= योगमायाको जलसमाधिको सन्दर्भ आठौं अनुच्छेदमा छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिएका वाक्यहरु जीवनको कुन अनुछेदमा छन्, पत्ता लगाउनुहोस :</h5>
        <p>(क) चौथो अनुछेदमा</p>
        <p>(ख) तेस्रो अनुछेदमा</p>
        <p>(ग) सातौ अनुछेदमा</p>
        <p>(घ) सातौ अनुछेदमा</p>
        <p>(ङ) नवौ अनुछेदमा</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिएका मितिमा योगमायाको जीवनसंग सम्बन्धित कुन कुन घटना भएको हुन्, भन्नुहोस् : </h5>
        <p>(क) वि.स १९२५ : जन्म भएको एक वर्ष पछाडिको समय (बाल्यकालको अवस्था, पारिवारिक परिवेशमा बसिरहेको समय।)</p>
        <p>(ख) वि.स. १९७३ : छोरी नैनकला र भाइका साथ मझुवावेंसी पुगिन्।</p>
        <p>(ग) वि.स. १९८२ : नेपालमा दास प्रथाको अन्त्य भएको घोषणा भयो, जसले योगमायाको विचार र आन्दोलनमा थप ऊर्जा थप्यो।</p>
        <p>(घ) वि.स. १९८८: उफौलीटारस्थित योगमायाको कुटी अरुण खोलाले बगायो, जुन घटनाले उनलाई अर्को स्थानमा बसाइँ सर्न बाध्य तुल्यायो।</p>
        <p>(ङ) वि.सं. १९९२ : आफ्ना अनुयायीसहित खाम्पालुङ हिमाल पार गर्दै तपस्या गरिन्।</p>
        <p>(च) वि.सं १९९३ : श्री ३ जुद्धसमसेरसँग भेट गरी आफ्ना सामाजिक सुधारका मागहरू राखिन्।</p>
        <p>(छ) वि.सं. १९९५ : आफ्ना मागहरू पूरा नभए अनुयायीसहित अग्निसमाधि लिने चेतावनी/घोषणा गरिन्।</p>
        <p>(ज) वि.सं. १९९७ : भोजपुरकै चायाबोटे सिरान, तोरीबारीको छेउको अग्लो थुम्कामा बसेर तेइस दिनसम्म तपस्या गरिन्।</p>
        <p>(झ) वि.सं. १९९८ : भोजपुरकै चायाबोटे सिरान, तोरीबारीको छेउको अग्लो थुम्कामा बसेर तेइस दिनसम्म तपस्या गरिन्।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका आधारमा घटनाक्रम मिलाएर लेख्नुहोस् :</h5>
        <p>(झ) विधवा हुनु र पुनर्विवाह हुनु,</p>
        <p>(ग) भागेर माइती जानू,</p>
        <p>(घ) आसामबाट फर्कनु,</p>
        <p>(ङ) आर्यसमाजी हुनु,</p>
        <p>(च) दीक्षा लिई सन्यासी बन्नु,</p>
        <p>(ञ) उफ्रौलीटारमा कुटी बनाउनु,</p>
        <p>(ज) निराहर, अल्पहार र जलाहार भएर तपस्या गर्नु,</p>
        <p>(छ) दासप्रथा, सतिप्रथाका विरुद्ध आवाज दिनु,</p>
        <p>(क) अग्निसमाधिको घोषणा तर असफल,</p>
        <p>(ख) जलसमाधिको तयारी र सफलता,</p>
      </div>
      <hr/>
      <div>
        <h5>५. पाठको चौथो अनुच्छेद पढ्नुहोस् र सोधिएका प्रश्नहरुको छोटोदिनुहोस् :</h5>
        <h5>(क) योगमायाले कुटी बनाएको ठाउँहरुको नाम लेख्नुहोस् ।</h5>
        <p>= योगमायाले तपस्या गर्ने र साधना गर्ने उद्देश्यले विभिन्न ठाउँहरूमा कुटी बनाएकी थिइन्। ती ठाउँहरू हुन्– मझुवावेँसी, उफ्रौलीटार, र गौडिनी। यी सबै स्थानहरू प्राकृतिक, शान्त र एकान्त थिए, जसले योगमायाको साधना र समाज सुधारको कामलाई सहज बनाएको थियो।</p>
        <h5>(ख) मानिसहरु योगमायासँग प्रभावित हुनुको कारण के हो ?</h5>
        <p>= योगमाया बहुपठित, ज्ञानी, अनुभवी र धर्मशास्त्रमा दख्खल राख्ने धार्मिक नेतृ थिइन्। उनले पण्डितहरूसँग शास्त्रार्थ गर्न सक्ने क्षमता राख्थिन् र धाराप्रवाह रूपमा प्रवचन दिन सक्ने खुबी पनि थिई। यही कारणले गर्दा धेरै मानिसहरू उनको विचार, बोली, आत्मविश्वास र आध्यात्मिक प्रभावले मोहित भएर उनलाई अनुसरण गर्न थालेका थिए।</p>
        <h5>(ग) योगमायाले किन तपस्या गरेकी हुन् ?</h5>
        <p>= योगमायाले साधनाको प्राप्ति, आत्मिक शुद्धता, र संसारिक मोहबाट मुक्त हुने उद्देश्य लिएर कठोर तपस्या गरेकी हुन्। उनको तपस्याको मूल उद्देश्य व्यक्तिगत मोक्ष मात्र नभई समाजमा व्याप्त अन्याय, अत्याचार, अन्धविश्वास र कुरीतिहरूको अन्त्य गर्नु पनि थियो।</p>
        <h5>(घ) 'उनी कहिले निराहार , कहिले जलाहार , कहिले अल्पहार तपस्यागर्थिन् '' भन्नुको तात्पर्य के हो ?</h5>
        <p>= यस वाक्यांशको तात्पर्य, योगमायाले अत्यन्त कठिन र कठोर तपस्या गर्थिन् भन्ने हो। कहिले पूर्णरूपमा केही नखाई (निराहार), कहिले केवल पानी सेवन गरेर (जलाहार), र कहिले थोरै मात्र भोजन गरेर (अल्पहार) उनले शरीरलाई कष्ट दिँदै आध्यात्मिक अभ्यासलाई निरन्तरता दिइन्। यो उनले संसारिक लोभ–मोह त्यागेको संकेत हो, साथै समाज सुधारको लागि आत्मसमर्पणको उच्चतम उदाहरण पनि हो।</p>
        <h5>(ङ) योगमायाले जलसमाधि नलिएको भए आन्दोलनले कस्तो स्वरुप लिन्थ्यो होला, अनुमान गरि लेख्नुहोस् ।</h5>
        <p>= यदि योगमायाले जलसमाधि नलिएर संघर्ष जारी राखेकी भए, सम्भवतः त्यो आन्दोलन शसस्त्र संघर्ष वा जनविद्रोहको रूप लिन सक्थ्यो। उनका अनुयायीहरूको ठूलो सङ्ख्या, उनीभित्रको दृढता, र राज्यप्रति असन्तुष्टि हेर्दा लाग्छ कि सामाजिक न्यायको माग गर्दै प्रतिक्रिया र विद्रोहात्मक स्वरूप लिने सम्भावना उच्च थियो। त्यो आन्दोलनले ऐतिहासिक राजनीतिक परिवर्तन ल्याउन सक्थ्यो भन्ने पनि अनुमान गर्न सकिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. 'योगमाया छुवाछूतरहित ………..अविस्मरणीय रहेको छ' जीवनीको अंश पढी सोधिएका प्रश्नहरुकोदिनुहोस् ।</h5>
        <h5>(क) योगमाया कस्तो समाजको खोजीमा लागिन् ?</h5>
        <p>= योगमाया एक न्यायपूर्ण र समतामूलक समाजको खोजीमा लागेकी थिइन्। उनी छुवाछुत, शोषण, अन्याय, अत्याचार, धर्मको नाममा गरिने पाखण्ड, र भ्रष्टाचारविरुद्ध आवाज उठाउँदै छुवाछूत–रहित, शोषण–रहित र भ्रष्टाचार–रहित समाजको निर्माणको अभियानमा लागिन्। उनी धर्म, जात, लिङ्ग, वर्गका आधारमा गरिने विभेदलाई अस्वीकार गर्थिन्।</p>
        <h5>(ख) तत्कालीन समाजले आफ्नो विचारलाई आविस्कार गरेपछि उनले कसरी विद्रोह गरिन् ?</h5>
        <p>= तत्कालीन समाजले योगमायाको विचार, सुधारवादी दृष्टिकोण र परिवर्तनको आवाजलाई नकारात्मक रूपमा लिएर अस्वीकार गर्‍यो। उनले आफ्ना मागहरू राज्यसमक्ष राख्दा पनि बेवास्ता गरियो। जब न्याय र परिवर्तनका सबै मार्गहरू बन्द भए, तब उनले सामूहिक जलसमाधि लिएर विद्रोहको चरम रूप देखाइन्। यो कदम तत्कालीन राज्यव्यवस्था र सामाजिक संरचनाको विरोधमा गरिएको शान्त, तर शक्तिशाली विद्रोह थियो।</p>
        <h5>(ग) योगमायाको सम्मानमा के कस्ता कामहरु भएका छन् ?</h5>
        <p>= योगमायाको स्मृतिमा विविध सम्मानजनक कार्यहरू सम्पन्न भएका छन्। तीमध्ये प्रमुख हुन्:
</p><p>
1. उनको वाणी र शिक्षालाई समेटिएको ‘सर्वाथ योगवाणी’ नामक कृतिको प्रकाशन,
</p><p>
2. विभिन्न लेखकहरूले तयार पारेका अनुसन्धानात्मक कृतिहरू,
</p><p>
3. योगमायाको जीवन र संघर्षमा आधारित ‘योगमाया’ शीर्षकको उपन्यास प्रकाशन,
</p><p>
4. साथै उनले थालेको आन्दोलन र त्यागलाई जनमानसमा पुर्‍याउने अनेक प्रयासहरू गरिएका छन्।</p>
      </div>
      <hr/>
      <div>
        <h5>७. दिइएको जीवनीको अंश पढी सोधिएका प्रश्नहरुकोदिनुहोस् ।</h5>
        <h5>(क) योगमायाको धर्मसम्बन्धी मान्यता कस्तो रहेको थियो ?</h5>
        <p>= योगमायाको धर्मसम्बन्धी मान्यता अत्यन्तै सुधारमुखी र समानतामूलक थियो। उनले धर्मका नाममा हुने छुवाछुत, जातीय विभेद, शोषण, र सामाजिक अन्यायको खुलेर विरोध गरेकी थिइन्। उनको विश्वास थियो कि धार्मिक गतिविधिमा सबै जात, वर्ग, लिङ्गका व्यक्तिहरू बिना कुनै भेदभाव समान रूपमा सहभागी हुनुपर्छ। पूजा, आराधना, प्रसाद ग्रहण, र भजनमा सबैलाई समान स्थान दिनुपर्ने उनको सोच थियो। त्यसैले उनी सहिष्णु, समतामूलक र न्याययुक्त धर्मको पक्षधर थिइन्।</p>
        <h5>(ख) पाठसमेतका आधारमा योगमायाले गरेका सुधारका प्रयासहरुको वर्णन गर्नुहोस् ।</h5>
        <p>= योगमायाले समाज सुधारका निम्ति अनेकौं क्रान्तिकारी कदमहरू चालेकी थिइन्। उनले सतीप्रथा, छुवाछुत, जातीय र लैङ्गिक विभेदजस्ता सामाजिक कुरीतिहरूको विरुद्ध ध्यान, तपस्या, प्रवचन र जनचेतनामूलक क्रियाकलापमार्फत आवाज उठाइन्।
उनले धार्मिक समानता ल्याउने प्रयास गर्दै सबैलाई भेदभाव नगरी धर्ममा सहभागी गराइन्।</p><p>

साथै, उनले वर्णाश्रम व्यवस्थाको विरोध गर्दै सबैका लागि विभेदरहित, न्यायपूर्ण, र समतामूलक समाज निर्माणको अभियान चलाइन्। जब राज्यले उनका मागहरू अस्वीकार गर्‍यो, उनले अन्ततः जलसमाधि लिएर एक ऐतिहासिक विद्रोह र चेतनामूलक क्रान्ति गरेकी थिइन्। उनका यी कार्यहरू नेपाली समाज सुधार आन्दोलनमा अविस्मरणीय योगदानका रूपमा सम्झिन्छन्।</p>
      </div>
      <hr/>
      <div>
        <h5>८. उत्तर दिनुहोस् :</h5>
        <h5>(क) योगमायाको बाल्यकाल र किशोरावस्था कस्तो रह्यो ?</h5>
        <p>= योगमायाको बाल्यकाल र किशोरावस्था अत्यन्तै पीडादायक र संघर्षपूर्ण रह्यो । वि.सं. १९२४ मा जन्मिएकी उनी ७ वर्षको उमेरमै सामाजिक परम्पराअनुसार विवाह गरेर ९ वर्षमै विधवा भइन् । सानो उमेरको सरल स्वभावकै कारण उनलाई घर र समाजबाट तिरस्कार र यातना सहनुपर्‍यो । चौध वर्षसम्म घरमै दुःख झेलिन् र माइती जाँदा पनि फेरि घर फर्काउने प्रयास भयो । अन्ततः उनले घर र माइती दुवै त्यागेर आसाम पुगिन् र त्यहाँ दोस्रो विवाह गरिन्, तर केही वर्षमै उनका दोस्रो पति पनि बिते । यसरी उनको बाल्यकाल र किशोरावस्था निरन्तर पीडा, सामाजिक अन्याय र अपमानले भरिएको थियो ।</p>
       <h5>(ख) योगमाया कसरी अध्यात्मिक विषयमा आकृष्ट भइन् ?</h5>
       <p>= योगमायाको पहिलो पतिको मृत्युपछि उनले शारीरिक र मानसिक यातना भोगिन् र घर तथा माइतीबाट उपेक्षित हुँदै विद्रोहको चेतना लिएर आसाम पुगिन् । त्यहाँ पुगेर पुनः विवाह गरी नैनकला नामकी छोरी जन्माइन् । त्यसपछि उनले सामाजिक क्रियाकलापमा सक्रिय सहभागिता जनाउन थालिन्, जसमा त्यस समयमा सबैभन्दा प्रचलित गतिविधि पूजा, प्रार्थना र धार्मिक अनुष्ठान थिए । यिनै आध्यात्मिक गतिविधिमा संलग्न रहँदा उनले नेतृत्व गर्न थालेकी थिइन्, जसले गर्दा उनी क्रमशः अध्यात्मतर्फ आकर्षित हुँदै गइन् ।</p>
       <h5>(ग) योगमायाको साधना र तपस्याको बारेमा उल्लेख गर्नुहोस् ।</h5>
       <p>= सन्यास लिएका पछि योगमायाले कठोर साधना र तपस्याको अभ्यास गरिन्, जसमा निराहार, जलाहार र अल्पहार जस्ता विधिहरू प्रयोग हुन्थे । उनी धाराप्रवाह प्रवचन दिने क्षमताको कारण भोजपुर क्षेत्रका धेरै भक्तजनहरू उनलाई सुन्न आउँथे । उफ्रौलीटारको फराकिलो जमिनमा बसोबास गर्दै उनले भक्तजनलाई समेट्न कटी निर्माण गरिन् । मौसम र वातावरणअनुसार शरीरलाई अनुकूल बनाउन उनी कहिले-काहीँ अरुण नदीमा आधा शरीर डुबाएर बस्थिन्, त कहिले गर्मीमा पञ्चारित ताप्थिन् । यस्तो कठोर तपस्याले उनी आत्मबल र आत्मनियन्त्रणमा दृढ बनिन् । उनले चायाँबोटे सिरान, तोरीबारीको छेउको अग्लो थुम्कामा २३ दिनसम्म तपस्या गरेकी थिइन् । उनका साधना र तपस्याको मूल उद्देश्य जीवनका लोभ-मोहबाट मुक्त भई समाज सुधारको मार्गमा लाग्नु थियो ।</p>
       <h5>(घ) योगमायाको अग्निसमाधिको योजना कसरी असफल भयो ?</h5>
       <p>= योगमायाको अग्निसमाधि हुनुभन्दा एक दिनअघि नै धनकुटाबाट वडाहाकिम साधव समसेरको नेतृत्वमा खटिएको फौज र भोजपुरबाट पठाइएको थप सुरक्षाकर्मीहरूले उनी बसेको क्षेत्रलाई घेरा हालेर कडा निगरानी गरे । सरकारले उक्त अग्निसमाधिमा रोक लगाउँदै प्रतिबन्ध लगाएपछि योगमायाको अग्निसमाधिको योजना असफल भयो ।</p>
       <h5>(ङ) योगमायाको जेवनीबाट पाइने शिक्षा के हो ?</h5>
       <p>= योगमायाको जीवनीबाट हामीले जस्तोसुकै कठिन परिस्थिति आए पनि पछाडि नहटी साहसका साथ अगाडि बढ्नुपर्छ भन्ने शिक्षा प्राप्त गर्छौं । उनले औपचारिक शिक्षा नपाए पनि स्वअनुभव र स्वसिकाइबाट गहिरो ज्ञान आर्जन गरिन् र ध्यान, योगसाधना तथा चिन्तनमार्फत समाजलाई नयाँ दिशा दिने प्रयास गरिन् । उनका जीवनबाट हामीले अन्याय र अपमानको विरुद्धमा आवाज उठाउनुपर्छ र आत्मबल तथा आत्मविश्वासको माध्यमबाट पनि ज्ञान प्राप्त गरेर समाज सुधारमा लाग्न सकिन्छ भन्ने प्रेरणा पाइन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. व्याख्या गर्नुहोस् :</h5>
        <h5>(क) यी तपस्याका विविध ……………………
…………चाहना राख्नु थियो ।</h5>
<p>= प्रस्तुत अंश कक्षा ११ को नेपाली पाठ्यपुस्तकमा समावेश ‘योगमाया’ नामक जीवनीबाट लिइएको हो, जसका लेखक यही पाठ्यपुस्तकका पनि लेखक हुन् । यस अंशमा योगमायाको कठोर तपस्या, आध्यात्मिक अभ्यास र समाजप्रतिको योगदानको चर्चा गरिएको छ । यो अंश योगमायाले जीवनका लोभ–मोह त्यागी समाज सुधारका लागि अपनाएको कठोर साधना र विद्रोहका विषयमा आधारित छ । </p>
<p>योगमायाको जीवन प्रारम्भदेखि नै पीडादायक रह्यो । कम उमेरमा विवाह, पतिको चाँडै मृत्यु, समाज र परिवारको तिरस्कार, अनि दोस्रो विवाहपछि फेरि विधवा हुनुपरेको पीडाले उनलाई आध्यात्मिक मार्गमा लाग्न प्रेरित गर्‍यो । उनले स्वर्गद्वारीमा दीक्षा लिएर सन्यासी जीवन अंगालिन् र कठोर तपस्याको अभ्यास गर्न थालिन्, जसमा निराहार, जलाहार, गर्मीमा तापिने, नदीमा डुबेर बस्नेजस्ता कठिन विधिहरू समावेश थिए । उनले चायाँबोटे जस्ता एकान्त स्थानमा बस्दै समाजमा व्याप्त कुरीति, अन्याय र विभेदको विरोध गर्न थालिन् । योग, ध्यान र चिन्तनमार्फत उनले समाज सुधारको चेतना फैलाउन नेतृत्व गरेकी थिइन् ।</p>
<p>यस अंशबाट स्पष्ट हुन्छ कि योगमायाको तपस्या व्यक्तिगत मुक्ति वा आत्मकल्याणका लागि मात्र थिएन; यो एक सामाजिक विद्रोह थियो, जसको उद्देश्य समाजमा रहेका विकृति, कुसंस्कृति र अन्यायको अन्त्य गर्नु थियो । उनले व्यक्तिगत स्वार्थभन्दा माथि उठी राष्ट्रिय र सामाजिक हितलाई प्राथमिकता दिइन् । अतः योगमायाको जीवनबाट हामीले आत्मबल, निडरता र सामाजिक परिवर्तनका लागि निरन्तर संघर्ष गर्ने प्रेरणा प्राप्त गर्छौं ।</p>
      </div>
      <hr/>
      <div>
        <h5>१०. सत्यनिष्ठा र समतामूलक समाजको स्थापनामा योगमायाले दिएको योगदानको चर्चा गर्नुहोस् :</h5>
        <p>= योगमायाले सत्यनिष्ठा र समतामूलक समाजको स्थापना गर्न उल्लेखनीय योगदान पुर्‍याइन् । उनले योगसाधना, तपस्या, ध्यान र सामाजिक व्यवहारलाई आत्मसाथ गर्दै समाजमा गहिरो रूपमा गढिएको सती प्रथा, दास प्रथा, छुवाछूत, लैंगिक असमानता, जातीय भेदभावजस्ता कुरीति र कुसंस्कारको विरुद्धमा सचेत विद्रोह गरिन् । उनी केवल आध्यात्मिक साधक मात्र नभई सामाजिक यथार्थप्रति सजग, न्यायप्रेमी र सुधारवादी नेतृ थिइन् । उनका लागि योगसाधना केवल आत्मकल्याणको बाटो नभई समाज सुधारको माध्यम पनि थियो ।</p>
        <p>उनले जीवनका लोभ, मोह त्यागी, कठोर तपस्याका माध्यमबाट आत्मबल विकास गर्दै धार्मिक, सामाजिक, आर्थिक र राजनीतिक विकृति हटाएर न्यायपूर्ण र समता आधारित समाज निर्माणको चाहना बोकेकी थिइन् । सानैदेखि उनले भोगेका सामाजिक विकृतिहरूले उनलाई वैराग्य भावनातर्फ प्रेरित गर्‍यो र उनले आफ्नो जन्मथलो मझुवावेँसीमा बसेर कुटी स्थापना गरी एक्लै योगसाधनामा लागिन् । समाजमा शास्त्रार्थ, बहस, पूजा र पुराणमार्फत चेतना फैलाउँदै उनले धार्मिक पुरुषहरूको जस्तै कर्तव्य निभाइन् ।</p>
        <p>निराहार, जलाहार, अल्पाहार, पञ्चाग्नि ताप्ने, नदीमा डुबेर ध्यान गर्नेजस्ता कठोर तपस्या गर्दै उनले समाजको विकृत संरचना भत्काउने अडान लिइन् । उनको तपस्या केवल व्यक्तिगत मुक्ति नभई सामाजिक समता र न्याय स्थापनाको मार्ग थियो । यसरी योगमायाले आफ्नो सम्पूर्ण जीवन सत्य, न्याय, समानता र सामाजिक परिवर्तनमा समर्पित गरेकी थिइन्, जुन आज पनि प्रेरणाका स्रोत बनेका छन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>११. दिइएको अनुच्छेद पढ्नुहोस् र सोधिएका प्रश्नहरुकोलेख्नुहोस् ।</h5>
        <h5>(क) सञ्चारका माध्यम तथा यातायतका साधनाले संसारलाई कसरी नजिक बनाएको छ ?</h5>
        <p>= सञ्चार र यातायातका आधुनिक साधनहरूले संसारका टाढा–टाढाका ठाउँलाई छिटो जोड्न सक्ने भएका छन् । यसले घरमै बसेर पनि मानिसहरू तुरुन्त सम्पर्क गर्न, समाचार थाहा पाउन र छिटो यात्रा गर्न सहज बनाएकोले संसार नजिक भएको छ ।</p>
        <h5>(ख) यन्त्रमानवले मानिसलाई कसरी सघाउँछ ?</h5>
        <p>= यन्त्रमानवले वैज्ञानिक, औद्योगिक, घरायसी लगायतका विभिन्न क्षेत्रमा मानिसले गर्ने काम गरेर मानिसहरूको कामलाई सजिलो र छिटो बनाउन मद्दत गर्छ।</p>
        <h5>(ग) वैज्ञानिक क्षेत्रमा भएको आशातीत प्रगतिले मानव जीवनलाई कस्तो बनाएको छ ?</h5>
        <p>= वैज्ञानिक प्रगतिले मानव जीवनलाई घरायसी कामदेखि कृषि, उद्योग र वाणिज्यसम्म सबै क्षेत्रमा सुखी, सम्पन्न र सुविधायुक्त बनाएको छ।</p>
        <h5>(घ) `वैज्ञानिक´ र `अनुसन्धान´ शब्दको निर्माण प्रक्रिया देखाउनुहोस् ।</h5>
        <p>= वैज्ञानिक : ( विज्ञान + इक )
अनुसन्धान : ( अनु + सन्धान )</p>
      </div>
      <hr/>
      <div>
        <h5>१२. दिइएको अनुच्छेद पढ्नुहोस् र सोधिएका प्रश्नहरुकोदिनुहोस् :</h5>
        <h5>(क) सरकारले किन निषेधाज्ञा जारी गरेको छ ?</h5>
        <p>= सरकारले महामारीको समय भएकाले निषेधाज्ञा जारी गरेको छ ।</p>
        <h5>(ख) जयमङ्गलले कसरी सनाखत गरेर हिँड्छ ?</h5>
        <p>= जयमङ्गलले हदम्यादको कुरै नबुझी सनाखत गरेर हिँड्छ ।</p>
        <h5>(ग) माथिको पाठमा `ऊ´ भनेको को होला ?</h5>
        <p>= माथिको पाठमा ऊ भनेको जयमङ्गल हो ।</p>
      </div> 
      <hr/>
       <div>
        <h5>शब्दकोशको सहायता लिई माथिका पाठमा आएका गाढा शब्दहरुको अर्थ लेख्नुहोस् ।</h5>
        <strong>निषेधाज्ञा</strong>
        <p>सरकार वा अधिकार प्राप्त निकायले कुनै विशेष काम गर्न रोक लगाउने औपचारिक आदेश।</p>
        <strong>इजलास</strong>
        <p>न्यायाधीश बसेर मुद्दाको सुनुवाइ गर्ने ठाउँ; अदालतको कक्ष।</p>
        <strong>कायलनामा</strong>
        <p>कसैसँगको सहमति वा मिलापत्र, विशेष गरी मुआब्जा वा सुलहसम्बन्धी सम्झौता।</p>
        <strong>गैरन्यायिक</strong>
        <p>न्यायालयसँग सम्बन्धित नभएको; अदालत बाहिरको।</p>
        <strong>उत्प्रेषण</strong>
        <p>पठाउने कार्य, विशेषतः पैसा वा सूचना देश/ठाउँ बाहिर पठाउने प्रक्रिया।</p>
        <strong>मुल्तबी</strong>
        <p>पछाडि सारिएको; केही समयका लागि स्थगित गरिएको।</p>
        <strong>जमानी</strong>
        <p>कसैको जिम्मा लिने व्यक्ति; जमानत दिने काम।</p>
        <strong>हदम्याद</strong>
        <p>कुनै कानुनी काम गर्ने समय सीमा; म्यादको अन्त्य।</p>
        <strong>सनाखत</strong>
        <p>पहिचान निश्चित गर्ने कार्य; कसैको सत्यता प्रमाणित गर्ने प्रक्रिया।</p>
        <strong>पेटबोली</strong>
        <p>कसैको असली नाम नभई प्रयोग गरिने अनौपचारिक नाम; बोलाउने नाम।</p>
        <strong>वन्दसवाल</strong>
        <p>प्रहरी वा न्यायालयमा गरिने लिखित बयान वा सोधपुछ।</p>
        <strong>सकारनामा</strong>
        <p>कुनै आरोप अस्वीकार गर्दै कारण खुलाउने दस्तावेज वा जवाफ।</p>
        <strong>दरपिठ</strong>
        <p>दर्ता गरिसकेको निवेदन, मुद्दा, वा उजुरी फिर्ता लिने प्रक्रिया।</p>
        <strong>महामारी</strong>
        <p>ठूलो क्षेत्रमा फैलिएको र धेरै व्यक्तिलाई असर गर्ने रोग।</p>
        <strong>हाजिरजमानी</strong>
        <p>कोही अदालतमा उपस्थित हुने शर्तमा जमानतमा रिहा गरिनु।</p>
       </div>
       <hr/>
       <div>
        <h3>व्याकरण</h3>
        <h3>नामयोगी</h3>
        <h5>१. दिइएका वाक्यमा नामयोगी पहिचान गरी लेख्नुहोस् ।</h5>
        <strong>(क) उनीहरुसित बन्दुक छ ।</strong>
        <p>नामयोगी: -सित</p>
        <strong>(ख) छानामाथि घिरौंला छ ।</strong>
        <p>नामयोगी: -माथि</p>
        <strong>(ग) रमेश घाटतर्फ लाग्यो ।</strong>
        <p>नामयोगी: -तर्फ</p>
        <strong>(घ) रुखबाट पात झर्‍यो ।</strong>
        <p>नामयोगी: -बाट</p>
        <strong>(ङ) ऊवाहेक कोही बोलेलन् ।</strong>
        <p>नामयोगी: -वाहेक</p>
        <strong>(च) जीवनभरि सुख पाइएन ।</strong>
        <p>नामयोगी: -भरि</p>
       </div>
       <hr/>
       <div>
        <h5>२. दिइएको जीवनीको अंशबाट दशओटा नामयोगी टिप्नुहोस् ।</h5>
        <p>अनुसार, सम्म , बाट , सँग , पछि , बाहिर, सहित, प्रति, माथि, पट्टी </p>
       </div>
       <div>
        <h5>३. `योगमाया´ पाठबाट दशओटा नामयोगी टिपी वाक्यमा प्रयोग हर्नुहोस् ।</h5>
        <p>सम्म : योगमायाले अन्तिम क्षण सम्म पनि आत्मबल गुमाइनन्।</p>
        <p>बाट : योगमायाको विचारले समाज बाट व्यापक समर्थन पायो।</p>
        <p>सित : उनी आफ्ना अनुयायीहरू सित अन्तिम छलफल गरिरहेकी थिइन्।</p>
        <p>सँग : योगमायाको संघर्ष सँग धेरै महिला प्रेरित भए।</p>
        <p>वाहेक : उनी वाहेक अरू कोही त्यस्तो साहसी थिएनन्।</p>
        <p>भरि : जीवन भरि उनले सत्य र न्यायको पक्षमा आवाज उठाइन्।</p>
        <p>तर्फ : सरकार योगमायाको आन्दोलन तर्फ गम्भीर भएन।</p>
        <p>माथि : उनको विचारधारामा राज्य माथि गम्भीर प्रश्न उठाइएका थिए।</p>
        <p>समेत : योगमायाले महिला अधिकारको कुरा समेत उठाएकी थिइन्।</p>
        <p>अनुसार : ऐतिहासिक विवरण अनुसार, उनले धेरै अनुयायीहरू तयार गरेकी थिइन्।</p>
       </div>
       <hr/>
       <div>
        <h3>क्रियायोगी</h3>
        <h5>१. दिइएका क्रियायोगी पहिचान गरी लेख्नुहोस् ।</h5>
        <p>हिजो, पारि, भर्खर, त्यता, ढिलो, ज्यादै, बिस्तारै, डराइडराइकन, पढ्न आदि ।</p>
       </div>
       <hr/>
       <div>
        <h5>२. दिइएको अनुच्छेदबाट बाह्रओटा क्रियायोगी टिप्नुहोस् ।</h5>
        <p>अस्ति, निकै, ढिलो, घर, गल्लीमा, यत्रतत्र, राति, अबेर, लडखडाउँदै, त्यहाँ, ज्यादै, राम्ररी ।</p>
       </div>
       <hr/>
       <div>
        <h5>३. पाठमा प्रयुक्त दसओटा क्रियायोगी टिपी वाक्यमा प्रयोग गर्नुहोस् ।</h5>
        <p><strong>घरमै :</strong> योगमाया मानसिक र शारीरिक यातना सहँदै १४ वर्ष घरमै बसिन्।</p>
        <p><strong>माइत :</strong> सासू र नन्दको यातना सहन नसकेपछि योगमाया माइत गएकी थिइन्। </p>
        <p><strong>पलाउन :</strong> योगमायामा बिस्तारै विद्रोहको चेतना पलाउन थाल्यो।</p>
        <p><strong>पुगेर :</strong> योगमाया आसाम पुगेर एक्लो महसुस गरिन्।</p>
        <p><strong>फर्काउन :</strong> योगमायालाई आफ्नै घर फर्काउन प्रयत्न गरियो।</p>
        <p><strong>नपाउँदै :</strong> योगमाया पति भनेर चिन्न नपाउँदै विधवा भइन्।</p>
        <p><strong>गर्न :</strong> योगमायाले नयाँ समाजको निर्माण गर्न धेरै तपस्या गरिन्।</p>
        <p><strong>खुलेरै : </strong>चन्द्र समसेरको दासप्रथा उन्मूलनको घोषणालाई योगमायाले खुलेरै प्रशंसा गरिन्।</p>
        <p><strong>बिस्तारै : </strong>योगमायाले बिस्तारै विद्रोहको आवाज उठाउन थालिन्।</p>
        <p><strong>जमिनमा :</strong> उफ्रौलिटारमा रहेको फराकिलो जमिनमा योगमाया सरिन्।</p>
       </div>
       <hr/>
       <div>
        <h3>संयोजक</h3>
        <h5>१. दिइएका वाक्य पढी संयोजक पहिचान गर्नुहोस् ।</h5>
        <p>(क) र</p>
        <p>(ख) तापनि</p>
        <p>(ग) एवं</p>
        <p>(घ) वा</p>
        <p>(ङ) अनि</p>
        <p>(च) तर</p>
       </div>
       <hr/>
       <div>
        <h5>२. योगमाया पाठबाट दशओटा संयोजक टिपोट गर्नुहोस् :</h5>
        <p>र, तथा, त्यसैले, तर, भन्ने, पनि, भनि, तथापि, अनि, जहाँ-त्यहीँ</p>
       </div>
       <hr/>
       <div>
        <h5>३. दिइएका संयोजक राखी वाक्य बनाउनुहोस् ।</h5>
        <p><strong>नत्र : </strong>तिमी पढ्न जाने भए जाऊ, नत्र म बुबालाई भनिदिन्छु।</p>
        <p><strong>किन्तु : </strong>देश विकासका लागि असल नेता आवश्यक हुन्छ, किन्तु अहिले देशमा असल नेताको अभाव देखिन्छ।</p>
        <p><strong>यद्यपि : </strong>यद्यपि मेरो घर घोराही होइन, म त्यहीँ बस्ने गर्छु।</p>
        <p><strong>पनि : </strong>म पनि तिमीसँग खेल्न जान्छु।</p>
        <p><strong>किनभने: </strong>राम आज पढ्न गएको छैन, किनभने ऊ बिरामी छ।</p>
        <p><strong>कि…कि : </strong>कि काम गर कि राम्रोसँग पढ।</p>
        <p><strong>तथापि : </strong>राम विदेश जान्छु भन्थ्यो, तथापि अहिले व्यवसाय गरेर बसेको छ।</p>
        <p><strong>न….न : </strong>न तिमी राम्रोसँग पढ्छौ न व्यवसाय नै गर्छौ।</p>
        <p><strong>भान्ने : </strong>पढेर जागिर नै गर्नुपर्छ भन्ने सोचाइ गलत हो।</p>
       </div>
       <hr/>
       <div>
        <h5>४. किन्तु , त्यसैले, जब…तब, किनभने, जहाँ …त्यहाँ प्रयोग गरी आफ्ना परिवारका बारेमा एक अनुच्छेद लेख्नुहोस् ।</h5>
        <p>म मेरो परिवारलाई धेरै माया गर्छु। जब घरमा सबैजना सँगै हुन्छन्, तब निकै रमाइलो माहोल बन्ने गर्छ। जहाँ म हुँ, त्यहाँ मेरो परिवारको सम्झना सधैं साथमा रहन्छ। हामी सबै एकअर्काको सहयोगी छौँ, किनभने आपसी माया र समझदारी नै हाम्रो परिवारको बलियो पक्ष हो। बुबा कडा परिश्रमी हुनुहुन्छ, किन्तु उहाँ सधैं हामीलाई समय दिनुहुन्छ। आमा हरेक कुरा व्यवस्थित राख्नुहुन्छ, त्यसैले घर सधैं सफा र शान्त देखिन्छ।</p>
       </div>
       <hr/>
       <div>
        <h3>विस्मयादिबोधक</h3>
        <h5>१. दिइएका वाक्य पढी विस्मयादिबोधक पहिचान गर्नुहोस् ।</h5>
        <p>(क) आहा!</p>
        <p>(ख) हरे!</p>
        <p>(ग) छ्या!</p>
        <p>(घ) आत्था!</p>
        <p>(ङ) स्याबास!</p>
       </div>
       <hr/>
       <div>
        <h5>२. दिइएका खाली ठाउँमा मिल्ने विस्मयादिबोधक राखी वाक्य पूरा गर्नुहोस् ।</h5>
        <p>(क) उफ्! कस्तो गर्मी ।</p>
        <p>(ख) धिक्कार! तिम्रो यो जिन्दगीलाई ।</p>
        <p>(ग) आहा! कति सुन्दर अक्षर ।</p>
        <p>(घ) आत्थु! कति चिसो हावा ।</p>
        <p>(ङ) छि! कस्तो दुर्गन्धित कोठा ।</p>
       </div>
       <hr/>
       <div>
        <h5>३. दिइएका विस्मयादिबोधक राखी वाक्य बनाउनुहोस् ।</h5>
        <p>(क) आम्मा धन्नै लडेको ।</p>
        <p>(ख) स्याबास! तिमीले राम्रो काम गर्यौ ।</p>
        <p>(ग) आब्बुइ! कति ठूलो सर्प ।</p>
        <p>(घ) छिछी! कति फोहोर कोठा ।</p>
        <p>(ङ) ऐया! कस्तो पेट दुख्यो ।</p>
       </div>
       <hr/>
       <div>
        <h3>निपात</h3>
        <h5>१. दिइएका वाक्य पढी निपात पहिचान गर्नुहोस् ।</h5>
        <p>(क) पो</p>
        <p>(ख) त</p>
        <p>(ग) रे</p>
        <p>(घ) लौ</p>
        <p>(ङ) क्यार</p>
       </div>
       <hr/>
       <div>
        <h5>२. दिइएको खाली ठाउँमा मिल्ने निपात राखी वाक्य पूरा गर्नुहोस् ।</h5>
        <p>(क) खै , मलाई केही थाहा छैन ।</p>
        <p>(ख) ल , आजलाई बिदा ।</p>
        <p>(ग) ऊ त आजै आउँछ ।</p>
        <p>(घ) ऊ डाक्टर नै हुन चाहन्छ ।</p>
        <p>(ङ) तँलाई पो केही चाहिँदैन ।</p>
        <p>(च) तिमी पनि हिजो आयौ र ?</p>
        <p>(छ) उनीहरु सहरमै बस्छन् रे ।</p>
       </div>
       <hr/>
       <div>
        <h5>३. दिइएका निपातहरुलाई अर्थ खुल्ने गरी वाक्यमा प्रयोग गर्नुहोस् ।</h5>
        <p><strong>रे : </strong>तिमीले रे उसलाई झूट बोलेका थियौ भनेर भनेछौ!</p>
        <p><strong>क्यारे : </strong>आज मौसम अली बद्लिएको क्यारे, हावा निकै चलिरहेको छ।</p>
        <p><strong>है : </strong>यो काम तिमीले आजै सक्नुपर्छ है।</p>
        <p><strong>अरे : </strong>अरे, तिमी यत्रो समयपछि आएको?</p>
        <p><strong>नि : </strong>म नि उसलाई धेरैपल्ट सम्झाएँ, तर उसले मानेन।</p>
        <p><strong>पो : </strong>ऊ त डाक्टर पो रहेछ, मलाई त थाहा नै थिएन।</p>
        <p><strong>ज्यादै : </strong>आज त घाम ज्यादै लागिरहेको छ।</p>
        <p><strong>ला : </strong>उसले मलाई ला आफ्नो किताब दिइहाल्यो।</p>
        <p><strong>खै : </strong>खै, उसले त आउँछ भनेको थियो, अहिलेसम्म देखिएन।</p>
       </div>
       <hr/>
       <div>
        <h3>पदवर्गसम्बन्धि थप अभ्यास</h3>
        <h5>१. रेखाङ्कन गरिएका पदहरुको पदवर्ग पहिचान गरी लेख्नुहोस् ।</h5>
        <p>(क) स्याबास : विस्मयादिबोधक</p>
        <p>नै : निपात</p>
        <p>भन्ने : संयोजक</p>
        <p>विश्वास : नाम</p>
        <p>त्यो : विशेषण</p>
        <p>झलझली : क्रियायोगी</p>
        <p>(ख) तिर : नामयोगी</p>
        <p>फर्केर : क्रियायोगी</p>
        <p>सक्छ : क्रियापद</p>
        <p>अरुहरु : सर्वनाम</p>
        <p>अनौठो : विशेषण</p>
        <p>र : निपात</p>
        <p>(ग) प्रचुर : विशेषण</p>
        <p>तापनि : संयोजक</p>
        <p>यिन : सर्वनाम</p>
        <p>सम्म : नामयोगी</p>
        <p>राम्ररी : क्रियायोगी</p>
        <p>शङ्का : नाम</p>
        <p>(घ) गरिबको : विशेषण</p>
        <p>माथी : क्रियायोगी</p>
        <p>सुन्दर : विशेषण</p>
        <p>किनभने : संयोजक</p>
        <p>सँग : नामयोगी</p>
        <p>(ङ) वाटाभरि : क्रियायोगी</p>
        <p>सामल : नाम</p>
        <p>अनि : संयोजक</p>
        <p>आइपुगेर : क्रियायोगी</p>
        <p>हामी : सर्वनाम</p>
        <p>कहाँ : क्रियायोगी</p>
        <p>भाग्यो : क्रियापद</p>
        <p>(च) अग्ला : विशेषण</p>
        <p>कलकल : क्रियायोगी</p>
        <p>सँग : नामयोगी</p>
        <p>सबै : विशेषण</p>
        <p>पर्यटक : नाम</p>
        <p>स्वागत : नाम</p>
        <p>र : निपात</p>
        <p>(छ) अरु : सर्वनाम</p>
        <p>सर्वथा : क्रियायोगी</p>
        <p>हुन्छ : क्रियापद</p>
        <p>तर : संयोजक</p>
        <p>पूर्वक : नामयोगी</p>
        <p>यो : विशेषण</p>
        <p>यिनी : सर्वनाम</p>
        <p>(ज) आहा : विस्मयादिबोधक</p>
        <p>यहाँ : सर्वनाम</p>
        <p>असाध्यै : क्रियायोगी</p>
        <p>सुनाउनुभयो : क्रियापद</p>
        <p>भनेर : संयोजक</p>
        <p>उन : सर्वनाम</p>
       </div>
       <hr/>
       <div>
        <h3>रुपायन</h3>
        <h5>२. दिइएको अनुच्छेदलाई स्त्रीलिङ्गमा परिवर्तन गर्नुहोस् :</h5>
        <p>भान्जी बजार गइन् । उनले त्यहाँ साथीहरुलाई भेटिन् । साथीहरुसँग धेरै बेर कुराकानी गरीन् । कुराकानी कै क्रममा उनले समय वितेको पत्तै पाइनन् । उनी हतार हतारकिनमेल गरेर घर फर्किन् ।</p>
       </div>
       <hr/>
       <div>
        <h5>३. दिइएको अनुच्छेदलाई तृतीय पुरुषमा परिवर्तन गर्नुहोस् :</h5>
        <p>उनीहरु समयमै विद्यालय पुगे । विद्यालयमा पुगेर उनले सबै सामानकोनिरीक्षण गरे । त्यसपछि शिक्षकको निर्देशनअनुसार उनीहरुले परियोजना कार्य गर्न थाले । यश क्रममा उनीहरुले नयाँ नयाँ वैज्ञानिक तथ्यहरु फेला पारे ।</p>
       </div>
    </div>
  )
}

export default Yogmaya
